import { motion } from "framer-motion";
import { fade } from "../_shared/motion";

export default function MissionSection() {
    return (
        <section className="relative bg-[#EFEBE0] py-20 md:py-24">
            <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
                <motion.div {...fade} className="md:col-span-5">
                    <p className="text-[12px] uppercase tracking-[0.2em] text-[#C8A24A] font-medium">
                        Our mission
                    </p>
                    <h2 className="mt-3 font-[Outfit] text-3xl md:text-4xl font-semibold tracking-tight">
                        Healing, accountability, and personal growth.
                    </h2>
                </motion.div>
                <motion.div {...fade} className="md:col-span-7">
                    <p className="text-[17px] leading-relaxed text-[#1A2230]/85">
                        Crossroads to Change Residential Treatment Center
                        exists to provide male youth with a safe,
                        structured, and therapeutic environment where
                        healing, accountability, emotional regulation, and
                        personal growth are cultivated through consistent
                        support, healthy relationships, and trauma-informed
                        care.
                    </p>
                </motion.div>
            </div>
        </section>
    );
}
